import { ConsoleErrorReporter, SentryErrorReporter, type ErrorReporter, type SentryLike } from "./ErrorReporter";

type MonitoringEnv = {
  readonly DEV?: boolean;
  readonly VITE_ERROR_REPORTING_ENABLED?: string;
};

type MonitoringWindow = Window & {
  Sentry?: SentryLike;
};

export function createErrorReporter(env: MonitoringEnv, root: MonitoringWindow = window): ErrorReporter {
  const enabled = env.VITE_ERROR_REPORTING_ENABLED === "true" && !env.DEV;
  if (enabled && root.Sentry) return new SentryErrorReporter(root.Sentry);
  return new ConsoleErrorReporter();
}

export function installGlobalErrorHandlers(reporter: ErrorReporter): void {
  window.addEventListener("error", (event) => {
    reporter.capture(event.error ?? event.message, {
      source: "window.error",
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    reporter.capture(event.reason, { source: "unhandledrejection" });
  });
}
